const SectionChartPair = ({ line, pie }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4 items-start">
    <div className="min-w-0">{line}</div>
    <div className="min-w-0">{pie}</div>
  </div>
);

export default SectionChartPair;
